<template>
  <section>
    <BaseTitleSection :title="title" class="mb-12 px-8" />
    <div class="tutor-testimonial">
      <div class="tutor-testimonial__main">
        <div class="w-full lg:w-1/3 order-2 lg:order-1 text-center lg:text-left">
          <BaseIcon name="format_quote" size="2xl" color="black" />
          <p class="text__headline-4-xs--bold lg:text__headline-4-md--bold mt-4 lg:mt-6">
            {{ item.main.feedback }}
          </p>
          <BaseAvatarTeacher
            :img-url="item.main.profile"
            :title="item.main.fullname"
            :subtitle="item.main.job_title"
            :size="{lg: '64', xs: '64'}"
            class="mt-8 justify-center lg:justify-start"
          />
          <CommonContinueRegistration btn-class="mt-5 lg:mt-14 w-full">
            <template #else>
              <BaseButton
                shadow
                size="md-lg"
                :label="$t('actions.signup_teach')"
                class="mt-5 lg:mt-14 w-full lg:w-[200px]"
                @click="$emit('signup')"
              />
            </template>
          </CommonContinueRegistration>
        </div>
        <div class="w-full lg:w-2/3 order-1 lg:order-2">
          <div class="w-full rounded-2xl">
            <BasePlayerBasic
              classes=""
              :src="item.main.video"
              :cover="item.main.video_cover"
            />
          </div>
        </div>
      </div>
      <div class="tutor-testimonial__list">
        <div class="w-[1000px] lg:w-auto flex flex-row space-x-3 flex-wrap lg:flex-nowrap">
          <div v-for="(el,key) in item.list" :key="key" class="item">
            <div class="rounded-2xl">
              <BasePlayerBasic
                classes=""
                :src="el.video"
                :cover="el.video_cover"
                size="xs"
              />
            </div>
            <div class="text-center">
              <BaseIcon name="format_quote" size="2xl" />
            </div>
            <p class="item__title">
              {{ el.feedback }}
            </p>
            <div class="w-fit mx-auto mt-4 lg:mt-0">
              <BaseAvatarTeacher
                :img-url="el.profile"
                :title="el.fullname"
                :subtitle="el.job_title"
                :size="{lg: '64', xs: '64'}"
                class="justify-center mb-4"
              />
              <!--     <BaseSeparator />
                         <BaseButton
                 flat
                 :label="$t('common.actions.see_profile')"
                 class="mx-auto mt-5"
               />-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import BaseTitleSection from '@design-system/base/title/title-section.vue'
import BasePlayerBasic from '@design-system/base/player/player-basic.vue'
import { mapGetters } from 'vuex'
import CommonContinueRegistration from '~/components/common/continue-registration.vue'
export default {
  name: 'StartTeachingTutorTestimonial',
  components: {
    CommonContinueRegistration,
    BaseTitleSection,
    BasePlayerBasic
  },
  computed: {
    ...mapGetters('global', ['getTestimonials']),
    ...mapGetters('local', ['getStepStatus']),
    title () {
      return 'What do our tutors say about Ostado?'
    },
    item () {
      const list = this.getTestimonials.slice(1, 4)
      return {
        main: { ...this.getTestimonials[0] },
        list
      }
    }
  }
}
</script>

<style scoped lang="scss">
.tutor-testimonial {
  @apply container;
  &__main {
    @apply flex flex-col lg:flex-row items-center border border-primary-100 rounded-2xl p-4 mb-12
    lg:space-x-12;
  }
  &__list {
    @apply relative w-full overflow-x-auto;
    &::-webkit-scrollbar {
      width: 0;  /* Remove scrollbar space */
      background: transparent;  /* Optional: just make scrollbar invisible */
    }
    .item {
      @apply border border-primary-100 rounded-2xl p-4 lg:w-1/3 w-[300px];
      &__title {
        @apply text__body-3-md--regular min-h-[168px] text-body-2;
      }
    }
  }
}
</style>
